// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-box[data-v-43191b78]{display:flex;align-items:center}.search-box .input-box[data-v-43191b78]{width:350px;margin-right:23px}.search-box .input-box[data-v-43191b78] .el-input__suffix{padding-top:14px;cursor:pointer}.table-box[data-v-43191b78]{margin-top:13px}.page-box[data-v-43191b78]{margin-top:15px;padding-bottom:10px}.page-box[data-v-43191b78] .el-pagination{justify-content:flex-end;padding:0}", ""]);
// Exports
module.exports = exports;
